<template>
  <div class="signature-container">
    <label v-if="!isSigned">
      {{ $t('Type in your signature') }}
      <sup>*</sup>
    </label>
    <input
      ref="contract_signature"
      v-model="signature"
      :placeholder="$t('Type in your full name')"
      required="required"
      type="text"
      :disabled="disabled"
      name="contract_signature"
      :class="`form-control signature-input text-${direction}`"
      data-test="contract-signature-input"
    />
    <p v-if="signedAt && isSigned" class="c-gray-700">{{ $t('Signed on') }} {{ signedAt }}</p>
  </div>
</template>

<script>
export default {
  name: 'ContractFormSignature',

  props: {
    /**
     * Set the signature
     * to editable mode
     * Input would be disbaled if true
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * Set direction of text cursor.
     */
    direction: {
      type: String,
      default: 'center',
      validator(value) {
        return ['left', 'center', 'right'].includes(value)
      },
    },
    /**
     * Set intial signature for the field
     */
    initialSignature: {
      type: String,
      default: '',
    },
    /**
     * Set signed as signed.
     */
    isSigned: {
      type: Boolean,
      default: false,
    },
    /**
     * Set timestamp when signature was signed
     */
    signedAt: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      signature: this.initialSignature,
    }
  },
}
</script>

<style scoped lang="scss">
.signature-container {
  margin: 20px 0;

  label {
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 20px;
  }

  .signature-input {
    width: 100%;
    height: 56px;
    border-radius: 4px;
    font-family: Caveat !important;
    font-size: 24px;
    line-height: 20px;

    &:disabled {
      color: #cdcdd7;
      border: 1px solid #dfdfe6;
      background: #f7f7f7;
    }
  }
}
</style>
